// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
define(['lodash4'], _=>{

// https://stackoverflow.com/c/brightdata/articles/425

class ZMixPanel {
    constructor(){
        const _this = this;
        this.disabled = false;
        this.debug = false;
        try { this.debug = !!+localStorage.getItem('debug_mixpanel'); }
        catch(e){}
        this.Events = {
            page_view: 'Page View',
            sidebar_item_clicked: 'Sidebar Item Clicked',
        };
        this.context = [];
        this.people = {
            set(...args){
                if (_this.can_call())
                    _this.client.people.set(...args);
            }
        };
    }
    get client(){
        const client = window.mixpanel;
        return client?.track ? client : null;
    }
    get current_popup(){
        return this.context.popup[this.context.popup.length - 1];
    }
    can_call(){
    return !this.disabled && this.client;
    }
    set_debug(val){
        this.debug = !!val;
        localStorage.setItem('debug_mixpanel', this.debug ? 1 : 0);
        if (!this.client)
            return;
        this.client.set_config({debug: this.debug});
    }
    enable(){
        this.disabled = false;
    }
    disable(){
        this.disabled = true;
    }
    register(...args){
        if (this.can_call())
            this.client.register(...args);
    }
    identify(...args){
        if (this.can_call())
            this.client.identify(...args);
    }
    track(name, payload, _opt){
        // support event-names-like-this
        const is_dashed = name?.includes('-') && !name.includes(' ');
        let _name = is_dashed ? name : _.startCase(name);
        if (!_opt?.raw)
        {
            const context_prefix = this.context.map(c=>c.name).join(' ');
            const context_payload = this.context.reduce((acc, c)=>{
                return Object.assign(acc, c.data);
            }, {});
            _name = `${context_prefix} ${_name}`;
            payload = Object.assign({}, context_payload, payload);
        }
        if (this.debug)
        {
            console.log(`MIXPANEL(${this.disabled ? 'OFF' : 'ON'})|TRACK:`,
                _name, payload, _opt);
        }
        if (this.can_call())
        {
            try {
                this.client.track(_name, payload);
            } catch(e){
                console.error(e);
            }
        }
    }
    set_group(...args){
        if (this.can_call())
            this.client.set_group(...args);
    }
    get_group(...args){
        if (!this.can_call())
            return {set(){}, set_once(){}};
        return this.client.get_group(...args);
    }
    opt_out(...args){
        if (this.can_call())
            this.client.opt_out_tracking(...args);
    }
    add_context(name, data){
        if (this.has_context(name))
        {
            console.warn('Mixpanel',
            `Context ${name} was already registered`);
            return;
        }
        this.context.push({name, data});
    }
    has_context(name){
        return !!this.context.find(c=>c.name==name);
    }
    get_context_name(){
        return this.context.map(c=>c.name).join(' ');
    }
    remove_context(name){
        if (!this.has_context(name))
        {
            console.warn('Mixpanel',
                `Trying to remove not existing context ${name}`);
            return;
        }
        let context_index = this.context.findIndex(c=>c.name==name);
        this.context.splice(context_index, 1);
    }
    attach_track(name, payload, callback){
        return (...args)=>{
            this.track(name, payload);
            callback(...args);
        };
    }
}
const instance = new ZMixPanel();
window.zmixpanel = instance;
if (window.brd_conf?.is_zlxc)
    instance.disable();
return instance; });
